<script>
	import Bubble from '$lib/Components/Layout/Bubble/Bubble.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';
	import youtubeThumbnail from './images/IXPkJBO_cWE.jpg?w=610';
	import measuringWindow from './images/Karen-Measuring-images-Horiz-RGB-C.jpg';
	import wedge from './images/Wedge-vintage.jpg';
</script>

<Section>
	<p>
		We have a <a href="/about-indow/care/installation-resources"
			>customer resource page</a
		> full of advice on measuring, installing, or caring for your insert. Visit any
		time you have an issue.
	</p>
	<p>
		We use our laser measurement tool to take 6 measurements of windows to make
		our custom window inserts so they have a precise fit. We custom cut each
		insert to ensure a Snug Fit that creates an airtight seal.
	</p>
	<Image src={measuringWindow} />
	<p>
		The diagonal measurement is always a little harder to take because you have
		to hold the laser measure tool at an angle rather than placing it against
		the window frame. That’s why we created the diagonal extension tool. The
		laser magnetically snaps onto the diagonal tool, which can be adjusted to
		any angle and tightened, then measure as usual.
	</p>
</Section>
<Section>
	<h2>Helpful tips for using the diagonal extension laser measure tool:</h2>
	<Bubble>
		<ul>
			<li>
				<p>
					Make sure you're holding the button to create a triangle of
					resistance.
				</p>
				<ul>
					<li>
						<p>
							The feet of the tool don’t have rubber (for easy minor
							adjustments) so they can move when you click the laser’s button,
							changing the distance.
						</p>
					</li>
				</ul>
			</li>
			<li>
				<p>Use two hands on the laser measure tool.</p>

				<ul>
					<li>
						<p>This helps keep it steady when pressing the button.</p>
					</li>
				</ul>
			</li>
			<li>
				<p>Use a book to hold extension leg (black) in place.</p>
			</li>
			<li>
				<p>
					Hold your finger on the laser measure tool button and keep your eye on
					the laser dot.
				</p>
				<ul>
					<li>
						<p>
							Place one finger on the base of the red leg and one on the button
							at all times.
						</p>
					</li>
				</ul>
			</li>
		</ul>
	</Bubble>

	<p>Watch this video to get the finger placement down:</p>
	<Youtube
		src="https://www.youtube.com/watch?v=IXPkJBO_cWE"
		posterImageSrc={youtubeThumbnail}
	></Youtube>
</Section>
<Section>
	<h2>How to Measure for Window Inserts: We’re Experts</h2>
	<p>
		We know how to measure a window with our eyes closed—these tips come after
		years of experience. But, we’ve also helped a lot of people through this
		process and by the end of the first diagonal, they are a window measuring
		master.
	</p>
	<p>
		Some other silly tips: Do yoga before you start measuring. You’re going to
		have to hold your hands in one corner and crane your neck to look in the
		other corner. Doing some light stretching isn’t a bad idea. Also, keep the
		laser button half depressed at all times so you’re ready to take that
		measurement. Think of it like that arcade game Cyclone. It has a circle of
		lights and you have to press the button right when it passes in front of you
		to get the prize. Having it already pressed halfway saves milliseconds! The
		same is true for measuring windows.
	</p>
</Section>
<Section>
	<h2>Laser Measure Tool Extension Inspired by You!</h2>
	<p>
		Our diagonal extension tool was inspired by a customer. They requested that
		we include a wedge to rest the laser tool on to make measuring diagonal
		easier. What we made was a wooden block with foam. But as anyone with older
		windows knows, not all window angles come in 90 degrees. Our tool evolved
		into the one we have now, which can be adjusted to any angle.
	</p>
	<Image src={wedge} />
	<p>
		If you need any assistance measuring your windows, we’re here to help. And
		we’d love your feedback on the measuring process. You never know when you’re
		going to suggest our next measurement tool!
	</p>
	<p class="italic">
		Want some more window measurement tips? Read these blog posts: <a
			href="/resources/blog/what-is-a-frame-step">What is a Frame Step?</a
		>
		&
		<a href="/resources/blog/why-we-laser-measure-windows"
			>Why We Laser Measure Windows</a
		>.
	</p>
</Section>
